<template>
<el-form ref="downloadForm" :model="form" size="large" label-position="top">
    <el-form-item 
        label="🔗 Video Links (one per line)" 
        prop="urls" 
        :rules="[{ required: true, message: 'Please enter at least one video URL', trigger: 'blur' }]">
        <el-input 
            v-model="form.urls" 
            type="textarea" 
            :rows="8"
            placeholder="Paste video URLs here, one per line. You can paste multiple links at once.&#10;Example:&#10;https://www.boyfriendtv.com/videos/12345/video-title" 
            clearable>
        </el-input>
        <div class="text-sm text-gray-500 mt-2">
            You can paste multiple video links, one per line. Both direct video URLs and page URLs are supported.
        </div>
    </el-form-item>

	<div v-if="!extensionInfo.version">
		<div class="mb-4">
			<div class="mb-4">
				Please download and install the extension, 
                then come back and refresh this page to start downloading.
			</div>
			<div class="flex gap-4 items-center">
				<a :href="`anyloader-${config.extensionVersion}.zip`">
					<el-button :icon="ElIconChromeFilled">Download extension</el-button>
				</a>
				<el-popover title="How to install the extension" width="500" trigger="click">
					<template #reference>
						<div class="flex gap-2">
							<ElIconInfoFilled width="15" class="text-blue-500"></ElIconInfoFilled>
							<a class="text-blue-400 cursor-pointer">How to install</a>
						</div>
					</template>
					<ExtensionInfo></ExtensionInfo>
				</el-popover>
			</div>
		</div>
	</div>
	<div v-else-if="extensionInfo.version < config.extensionVersion">
		<div class="mb-4">
			<div class="mb-4">
				<el-alert title="Extension update required" type="warning" effect="light" show-icon :closable="false">
					<p> You have an outdated version of extension installed (v{{extensionInfo.version}})  </p>
                    <p> Please uninstall it, and download and install the latest version (v{{ config.extensionVersion }}) of the extension,  </p>
					<p> then come back and refresh this page to start downloading. </p>
				</el-alert>
			</div>
			<div class="flex gap-5 items-center">
				<a :href="`anyloader-${config.extensionVersion}.zip`">
					<el-button :icon="ElIconDownload">Download latest version</el-button>
				</a>
				<el-popover title="How to install the extension" width="500" trigger="click">
					<template #reference>
						<div class="flex gap-2">
							<ElIconInfoFilled width="15" class="text-blue-500"></ElIconInfoFilled>
							<a class="text-blue-400 cursor-pointer">How to install</a>
						</div>
					</template>
					<ExtensionInfo></ExtensionInfo>
				</el-popover>
			</div>
		</div>
	</div>
	<div>
		<el-button class="mb-2" type="primary" @click="$emit('download', form)" :icon="ElIconSearch">Find Media</el-button>
	</div>
</el-form>
</template>

<script>
const config = useConfig()
export default {
	props: {
		extensionInfo: Object,
		loading: Boolean
	},
	mounted () {
        if (this.$route.query.url) {
            this.form.urls = this.$route.query.url
            this.$nextTick(() => {
                this.$emit('download', this.form)
            })
        }
	},
	data: () => ({
		config,
		form: {
			urls: ''
		},
	})
}
</script>
